import React, { Component } from 'react'

import ReactEcharts from 'echarts-for-react'

export default class BBEChart extends Component {
  static getDescription() {
    return {
      name: 'BBEChart',
      component: BBEChart,
      label: 'BBEChart',
      variables: [
        {
          name: 'query',
          type: 'yasgui',
          label:
            'Query to fill the chart. first parameter is the type, second the amount for a pie/donut',
        },
        {
          name: 'charttype',
          type: 'select',
          label: 'charttype',
          options: [
            { label: 'Kies', value: 'Kies' },
            { label: 'Pie', value: 'Pie' },
            { label: 'Doughnut', value: 'Doughnut' },
            { label: 'Bar', value: 'Bar' },
            { label: 'Column', value: 'Col' },
            { label: 'stacked Column', value: 'ColStacked' },
            { label: 'stacked Bar', value: 'BarStacked' },
          ],
        },
        {
          name: 'title',
          type: 'text',
          label: 'title',
        },
        {
          name: 'color',
          type: 'array',
          label: 'optional colorscheme series,hexcolor... ok,#ffaacc',
        },
        {
          name: 'legend',
          type: 'boolean',
          label: 'legend',
        },
        {
          name: 'defaultMenu',
          type: 'boolean',
          label: 'defaultMenu',
        },
        {
          name: 'stringToColor',
          type: 'boolean',
          label: 'use string values to color chart',
        },
        {
          name: 'labelsInChart',
          type: 'boolean',
          label: 'labels in the chart',
        },
      ],
    }
  }

  stringToColour(str) {
    var hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    var colour = '#'
    for (let i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xff
      colour += ('00' + value.toString(16)).substr(-2)
    }
    return colour
  }

  processStringToColor(option) {
    //pie

    try {
      if (this.props.charttype === 'Pie') {
        option.color = []
        let data = option.series[0].data

        for (let n in data) {
          option.color.push(this.stringToColour(data[n].name))
        }
        return
      }
    } catch (e) {}

    try {
      if (this.props.charttype === 'Bar') {
        console.log(this.props.charttype, 'process string color', option)

        let data = option.legend.data
        let ndata = []
        for (let n in data) {
          let o = { value: option.series[0].data[n] }
          o.itemStyle = { color: this.stringToColour(data[n]) }
          ndata.push(o)
        }
        option.series[0].data = ndata
        return
      }
    } catch (e) {}
  }

  get2ParameterData() {
    // console.log("get 2d data");
    var data = []
    var par1 = this.props.data.head.vars[0]
    var par2 = this.props.data.head.vars[1]

    for (var n in this.props.data.results.bindings) {
      var binding = this.props.data.results.bindings[n]
      data.push({ name: binding[par1].value, value: binding[par2].value })
    }
    return data
  }
  get3ParameterData() {
    // console.log("get 3d data");
    var data = []
    var par1 = this.props.data.head.vars[0]
    var par2 = this.props.data.head.vars[1]
    var par3 = this.props.data.head.vars[2]
    for (var n in this.props.data.results.bindings) {
      var binding = this.props.data.results.bindings[n]
      data.push({
        name: binding[par1].value,
        value: binding[par2].value,
        value2: binding[par3].value,
      })
    }
    return data
  }
  get3ParameterDataStacked() {
    var par1 = this.props.data.head.vars[0]
    var par2 = this.props.data.head.vars[1]
    var par3 = this.props.data.head.vars[2]

    var sorting = {}
    var par2Sorting = {}
    var xseries = []
    var previousX = null

    for (var n in this.props.data.results.bindings) {
      var binding = this.props.data.results.bindings[n]
      var id = binding[par1].value
      if (id !== previousX) {
        previousX = id
        xseries.push(id)
      }
      var o = sorting[id]
      if (o == null) {
        o = {}
        sorting[id] = o
      }
      o[binding[par2].value] = binding[par3].value
      par2Sorting[binding[par2].value] = ''
    }

    var series = []
    var legend = []
    for (let n in par2Sorting) {
      var serie = []
      legend.push(n)
      for (let i in xseries) {
        o = sorting[xseries[i]]
        var value = o[n]
        if (value == null) {
          value = 0
        }
        serie.push(value)
      }
      var serieO = {
        name: n,
        type: 'bar',
        stack: 'yes',
        barWidth: '75%',
        data: serie,
      }
      series.push(serieO)
    }

    var option = {
      series: series,
      xAxis: [
        {
          type: 'category',
          data: xseries,
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
    }

    option.legend = {
      data: legend,
    }

    return option
  }

  get4ParameterData() {
    // console.log("get 4d data");
    var data = []
    var par1 = this.props.data.head.vars[0]
    var par2 = this.props.data.head.vars[1]
    var par3 = this.props.data.head.vars[2]
    var par4 = this.props.data.head.vars[3]
    for (var n in this.props.data.results.bindings) {
      var binding = this.props.data.results.bindings[n]
      data.push({
        name: binding[par1].value,
        value: binding[par2].value,
        value2: binding[par3].value,
        value3: binding[par4].value,
      })
    }
    return data
  }

  getOption() {
    // console.log(this.props.data);
    try {
      if (this.props.data == null) {
        return {}
      }
      if (this.props.charttype === 'BarStacked') {
        return this.getColBarOptionStacked(true)
      }
      if (this.props.charttype === 'ColStacked') {
        return this.getColBarOptionStacked(false)
      }

      var data = this.props.data
      var gdata = null
      if (data.head.vars.length === 2) {
        gdata = this.get2ParameterData()
      }
      if (data.head.vars.length === 3) {
        gdata = this.get3ParameterData()
      }
      if (data.head.vars.length === 4) {
        gdata = this.get4ParameterData()
      }

      if (gdata != null) {
        if (this.props.charttype === 'Pie') {
          return this.getPieOption(gdata, false)
        }
        if (this.props.charttype === 'Doughnut') {
          return this.getPieOption(gdata, true)
        }
        if (this.props.charttype === 'Bar') {
          return this.getColBarOption(gdata, true)
        }
        if (this.props.charttype === 'Col') {
          return this.getColBarOption(gdata, false)
        }
        console.log('geen charttype aanwezig')
      }
    } catch (error) {}

    return {}
  }

  getColBarOption(data, bar) {
    var dataX = []
    var dataY = []
    var dataY2 = []
    var dataY3 = []
    var legends1 = []
    var legendsH1 = {}
    var legends2 = []
    var legendsH2 = {}

    for (var n in data) {
      legendsH1[data[n].name] = ''
      legendsH2[data[n].value] = ''
      dataX.push(data[n].name)
      dataY.push(data[n].value)
      try {
        dataY2.push(data[n].value2)
      } catch (error) {}

      try {
        dataY3.push(data[n].value3)
      } catch (error) {}
    }
    for (let n in legendsH1) {
      legends1.push(n)
    }
    for (let n in legendsH2) {
      legends2.push(n)
    }

    var naam = this.props.data.head.vars[1]

    var series = [{ name: naam, type: 'bar', barWidth: '60%', data: dataY }]
    if (dataY2.length > 0) {
      var naam2 = this.props.data.head.vars[2]
      if (naam2 != null) {
        series = [
          { name: naam, type: 'bar', barWidth: '40%', data: dataY },
          { name: naam2, type: 'bar', barWidth: '40%', data: dataY2 },
        ]
      }
    }
    if (dataY3.length > 0) {
      var naam3 = this.props.data.head.vars[3]
      if (naam3 != null) {
        series = [
          { name: naam, type: 'bar', barWidth: '25%', data: dataY },
          { name: naam2, type: 'bar', barWidth: '25%', data: dataY2 },
          { name: naam3, type: 'bar', barWidth: '25%', data: dataY3 },
        ]
      }
    }

    var option = {
      color: ['#003366', '#006699', '#4cabce', '#e5323e'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: dataX,
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: series,
    }
    if (bar) {
      var temp = option.xAxis
      option.xAxis = option.yAxis
      option.yAxis = temp
    }
    //this.addToolbox(option);
    if (series.length === 1) {
      this.addLegend(option, legends1)
    } else {
      this.addLegend(option, legends2)
    }
    return option
  }
  addLegend(option, datax) {
    option.legend = { data: datax }
  }
  addToolbox(option) {
    option.toolbox = {
      show: true,
      orient: 'vertical',
      left: 'right',
      top: 'center',
      feature: {
        mark: { show: true, title: 'mark' },
        dataView: { show: true, readOnly: false, title: 'data view' },
        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
        title: { line: 'line', bar: 'bar', stack: 'stack', tiled: 'tiled' },
        //     restore: {show: true,title:"Reset"},
        saveAsImage: { show: true, title: 'save as Image' },
      },
    }
  }

  getPieOption2(data, doughnut) {
    var title = ''
    if (this.props.title != null) {
      title = this.props.title
    }
    var subtitle = ''
    if (this.props.subtitle != null) {
      subtitle = this.props.subtitle
    }
    var radius = '75%'
    if (doughnut) {
      radius = ['50%', '75%']
    }
    // render echarts option.
    let option = {}
    option = {
      title: {
        text: title,

        subtext: subtitle,
        left: 'center',
        top: '2%',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },

      series: [
        {
          type: 'pie',
          avoidLabelOverlap: true,
          //     roseType: 'radius',
          radius: radius,
          center: ['50%', '50%'],
          data: data,
          animation: true,
          label: {
            show: true,
          },
        },
      ],
    }

    if (this.props.legend === true) {
      option.legend = {
        orient: 'vertical',
        left: 'right',
        bottom: 10,
      }
    }

    return option
  }

  getColBarOptionStacked(bar) {
    var option = this.get3ParameterDataStacked()

    option.color = ['#003366', '#006699', '#4cabce', '#e5323e']
    option.tooltip = {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
      },
    }
    option.grid = {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    }
    option.plotarea = {
      'adjust-layout': true,
    }

    return option
  }

  getPieOption(data, doughnut) {
    // console.log("getPIE option ");
    var title = ''
    if (this.props.title != null) {
      title = this.props.title
    }
    var subtitle = ''
    if (this.props.subtitle != null) {
      subtitle = this.props.subtitle
    }
    var radius = '75%'
    if (doughnut) {
      radius = ['50%', '75%']
    }
    // render echarts option.
    let option = {}
    option = {
      title: {
        text: title,

        subtext: subtitle,
        left: 'center',
        top: '2%',
      },

      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },

      series: [
        {
          type: 'pie',
          avoidLabelOverlap: true,
          //     roseType: 'radius',
          radius: radius,
          center: ['50%', '50%'],
          data: data,
          animation: true,
          label: {
            show: true,
          },
        },
      ],
    }

    if (this.props.legend === true) {
      option.legend = {
        orient: 'vertical',
        left: 'right',
        bottom: 10,
        'adjust-layout': true,
      }
    }

    return option
  }

  render() {
    let option = this.getOption()
    if (this.props.stringToColor) {
      this.processStringToColor(option)
    }

    option.width = '98%'
    if (this.props.title != null) {
      option.title = {
        text: this.props.title,
        'adjust-layout': true,
      }
      if (this.props.defaultMenu === true) {
        this.addToolbox(option)
      }
      if (this.props.legend === false) {
        option.legend = null
      }
    }
    var labelOption = {}
    if (this.props.labelsInChart) {
      try {
        labelOption = {
          show: true,
          position: 'insideBottom',
          distance: 15,
          align: 'left',
          verticalAlign: 'middle',
          rotate: 90,
          formatter: '{c}  {name|{a}}',
          fontSize: 16,
          rich: {
            name: {},
          },
        }

        for (var n in option.series) {
          var serie = option.series[n]
          serie.label = labelOption
        }
      } catch (e) {}
    }
    //console.log(option);

    return (
      <ReactEcharts
        style={{ height: '92%', width: '95%' }}
        notMerge={true}
        lazyUpdate={false}
        option={option}
      />
    )
  }
}
